import { gql } from 'react-apollo';
import {
  ADMIN_DELETE_USER_START,
  ADMIN_DELETE_USER_SUCCESS,
  ADMIN_DELETE_USER_ERROR
} from '../../constants';

import history from '../../core/history';
import showToaster from '../../helpers/showToaster';

const mutation = gql`
  mutation deleteUser ($userId:String!, $userType: String) {
      deleteUser (userId:$userId, userType: $userType) {
        status
        errorMessage
      }
    }
  `;

export function deleteUser(userId) {

  return async (dispatch, getState, { client }) => {

    dispatch({
      type: ADMIN_DELETE_USER_START,
      data: userId
    });
    let isAdmin = getState()?.runtime?.isAdminAuthenticated;

    try {

      const { data } = await client.mutate({
        mutation,
        variables: { userId, userType: "admin" },
      });

      if (data.deleteUser.status == 200) {
        dispatch({
          type: ADMIN_DELETE_USER_SUCCESS,
        });
        isAdmin ? showToaster({ messageId: 'deleteUser', toasterType: 'success' }) : showToaster({ messageId: 'deleteUserAccount', toasterType: 'success' })

        isAdmin ? history.push('/siteadmin/users') : history.push('/');

      } else {
        dispatch({
          type: ADMIN_DELETE_USER_ERROR,
        });
        showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: data?.deleteUser?.errorMessage })
      }

    } catch (error) {
      dispatch({
        type: ADMIN_DELETE_USER_ERROR,
        payload: {
          error
        }
      });

    }

  };
}
